import PropTypes from 'prop-types';
import { useTranslation } from '@eti/providers';
import { css, cx, etiColors, mediaQueries } from '@eti/styles';
import { AIRLINES } from '../../../../../constants/searchFiltersConstants';
import { SelectedFilters } from '../../../constants/resultPropTypes';
import CheckboxFilter from './CheckboxFilter';

const filterStyles = css`
  @media ${mediaQueries.medium.up} {
    border-top: 1px dotted ${etiColors.grayScale[9]};
    flex: 0 0 100%;
    max-width: 100%;
    padding-bottom: 15px;
  }
`;

const Airlines = ({
  className,
  isInitiallyExpanded,
  isToggleable,
  onFilter,
  selectedFilters,
  marketingCarriers,
}) => {
  const { t } = useTranslation();

  return (
    <CheckboxFilter
      className={cx(filterStyles, className)}
      isInitiallyExpanded={isInitiallyExpanded}
      isToggleable={isToggleable}
      label={t('Result.SearchFilters.Airlines.Text')}
      name={AIRLINES}
      onFilter={onFilter}
      options={marketingCarriers}
      selectedValues={selectedFilters[AIRLINES]}
    />
  );
};

Airlines.propTypes = {
  className: PropTypes.string,
  isInitiallyExpanded: PropTypes.bool,
  isToggleable: PropTypes.bool,
  marketingCarriers: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string,
      name: PropTypes.string,
    }),
  ),
  onFilter: PropTypes.func,
  selectedFilters: SelectedFilters,
};

export default Airlines;
